import React, { FunctionComponent } from 'react';

import { default as MuiToolbar, ToolbarProps } from '@mui/material/Toolbar';

const ToolBar: FunctionComponent<ToolbarProps> = ({
  sx,
  children,
  disableGutters,
}: ToolbarProps) => {
  return (
    <MuiToolbar sx={sx} disableGutters={disableGutters}>
      {children}
    </MuiToolbar>
  );
};
export default ToolBar;
